import { z } from 'zod';

import {
  filterSchema,
  titleSchema,
} from '../../universal-widget/settingsSchema';

export const enterpriseRiskHeatmapAggregations = [
  'mean',
  'median',
  'worstCase',
] as const;

export type EnterpriseRiskHeatmapAggregation =
  (typeof enterpriseRiskHeatmapAggregations)[number];

/**
 * Settings for the enterprise risk heatmap widgets (RSP-6195): the shared
 * filtering + custom-title fields plus which aggregation of the enterprise
 * risk likelihood/impact dimensions to plot. Defaults to `mean` when unset.
 */
export const enterpriseRiskHeatmapSettingsSchema = filterSchema
  .and(titleSchema)
  .and(
    z.object({
      aggregation: z.enum(enterpriseRiskHeatmapAggregations).optional(),
    })
  );

export type EnterpriseRiskHeatmapSettings = z.infer<
  typeof enterpriseRiskHeatmapSettingsSchema
>;
